import { IonContent, IonPage } from '@ionic/react';
import './styles/DesktopLanding.css';

const DesktopLanding: React.FC = () => {
    return (
        <IonPage className="desktop-landing">
            <IonContent fullscreen>
                <div className="landing-container">
                    <div className="message-box">
                        <h1>This tool is designed for mobile use.</h1>
                        <p>
                            For the best experience, open this page on your mobile device. You'll receive a quick setup prompt to install the app and start using the calculator.
                        </p>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default DesktopLanding;